import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle, XCircle, Spinner, ArrowRight } from "@phosphor-icons/react";
import { useT } from "../context/LangContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MAX_POLLS = 8;

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");
  const [amount, setAmount] = useState(null);
  const { t } = useT();
  const c = t.payment;

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        setAmount(data.amount);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (data.status === "expired" || data.payment_status === "failed") { setState("error"); return; }
        if (attempts >= MAX_POLLS) { setState("pending"); return; }
        attempts += 1;
        setTimeout(poll, 2000);
      } catch (e) {
        if (attempts >= MAX_POLLS) { setState("error"); return; }
        attempts += 1;
        setTimeout(poll, 2000);
      }
    };
    poll();
  }, [sessionId]);

  return (
    <section className="min-h-screen flex items-center justify-center px-5 py-32" data-testid="payment-success-page">
      <div className="max-w-lg text-center">
        {state === "checking" && (
          <>
            <Spinner size={56} className="mx-auto animate-spin text-terracotta" />
            <h1 className="mt-8 font-display font-extrabold tracking-tighter text-3xl text-ink">{c.checking}</h1>
            <p className="mt-3 text-stone">{c.checkingBody}</p>
          </>
        )}
        {state === "paid" && (
          <>
            <CheckCircle size={72} weight="duotone" className="mx-auto text-forest" />
            <h1 className="mt-8 font-display font-extrabold tracking-tighter text-4xl text-ink">{c.paidTitle}</h1>
            <p className="mt-4 text-lg text-stone">{c.paidBody(amount)}</p>
            <Link to="/" data-testid="success-home-btn" className="mt-10 inline-flex items-center gap-2 rounded-full bg-terracotta px-8 py-4 font-semibold text-white transition-colors duration-200 hover:bg-terracotta-dark">
              {c.home} <ArrowRight size={18} />
            </Link>
          </>
        )}
        {state === "pending" && (
          <>
            <Spinner size={56} className="mx-auto text-ochre" />
            <h1 className="mt-8 font-display font-extrabold tracking-tighter text-3xl text-ink">{c.pendingTitle}</h1>
            <p className="mt-3 text-stone">{c.pendingBody}</p>
            <Link to="/" className="mt-8 inline-flex items-center gap-2 font-semibold text-terracotta">{c.home} <ArrowRight size={18} /></Link>
          </>
        )}
        {state === "error" && (
          <>
            <XCircle size={72} weight="duotone" className="mx-auto text-terracotta" />
            <h1 className="mt-8 font-display font-extrabold tracking-tighter text-3xl text-ink">{c.errorTitle}</h1>
            <p className="mt-3 text-stone">{c.errorBody}</p>
            <Link to="/sostienici" data-testid="error-retry-btn" className="mt-8 inline-flex items-center gap-2 rounded-full bg-terracotta px-7 py-3.5 font-semibold text-white transition-colors duration-200 hover:bg-terracotta-dark">
              {c.retry}
            </Link>
          </>
        )}
      </div>
    </section>
  );
}
